module.exports = __webpack_public_path__ + "static/media/home-hippo-gator.0889a20a.svg";